class ProgressiveImage {
  constructor(element) {
    this.element = element;
    this.lowQualitySrc = element.src;
    this.highQualitySrc = element.dataset.src;
    this.loaded = false;

    this.element.classList.add('progressive-image');
    this.element.classList.add('blur');
    this.element.classList.add('loading');

    this.loadHighQualityImage = this.loadHighQualityImage.bind(this);
    this.handleIntersect = this.handleIntersect.bind(this);
    this.cleanup = this.cleanup.bind(this);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersect, {
        rootMargin: '0px 0px 100px 0px' // Load 100px before entering viewport
      });
      this.observer.observe(this.element);
    } else {
      // Fallback for older browsers
      this.loadHighQualityImage();
    }
  }

  handleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.loaded) {
        this.loadHighQualityImage();
        observer.unobserve(this.element);
      }
    });
  }

  loadHighQualityImage() {
    if (this.loaded) return;

    const img = new Image();
    img.src = this.highQualitySrc;
    img.onload = () => {
      this.element.src = this.highQualitySrc;
      this.element.classList.remove('blur');
      this.element.classList.remove('loading');
      this.element.classList.add('loaded');
      this.loaded = true;
      this.cleanup();
    };
    img.onerror = () => {
      console.error(`Failed to load high-quality image: ${this.highQualitySrc}`);
      this.element.classList.remove('loading');
      // Keep low-quality image if high-quality fails
      this.cleanup();
    };

    // Cancel loading if user scrolls away quickly (not strictly cancellable for Image, but good practice)
    // For actual cancellation, one would use fetch with AbortController, but for simple image loading, it's not directly possible.
    // The observer unobserving on intersect handles the "preload only when needed" aspect.
  }

  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
    }
    // No other event listeners to clean up in this simple case
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.progressive-image').forEach(element => {
    new ProgressiveImage(element);
  });
}); 